import { WorkqueueService } from './../../../BaseFramework/core/http/workqueue.service';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataTransformService } from '../../shared-services/data-transform/data-transform.service';
import { UserInfoService } from 'app/BaseFramework/core';
import { InvestigationService } from 'app/BaseFramework/core/http/investigation.service';
import { DatePipe } from '@angular/common';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  ClientService,
  AppMetadataHandler,
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-transaction-summary-ribbon',
  templateUrl: './transaction-summary-ribbon.component.html',
  styleUrls: ['./transaction-summary-ribbon.component.scss'],
  providers: [
    DatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TransactionSummaryRibbonComponent),
      multi: true
    }
  ]
})
export class TransactionSummaryRibbonComponent implements OnInit, ControlValueAccessor {

  _currentComponentName = 'TransactionSummaryRibbonComponent'
  productTypeConfig = {
    productType: "New Business",
    productTypeNicename: "New Business",
    prodSubType: "Health Proposal",
    prodTagColor: "#2cb12b",
    prodTagIcon: 'heart',
  };
  percentCompleted: number = 60;
  underwritingWorksheetModal: boolean = false;

  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private policyService: PolicyService,
    private clientService: ClientService,
    private message: NzMessageService,
    public appMetadataHandler: AppMetadataHandler,
    private workQueueService: WorkqueueService,
    public dataTransformService: DataTransformService,     
    private userInfoService: UserInfoService,
    private investigationService: InvestigationService,
    private datePipe: DatePipe) { }

  writeValue(value: any): void {
    if (value)
      this.allComponentsData = value
  }
  registerOnChange(fn: any): void {

  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  //Declaraions which might need developer input
  claimsBasicDetailsForm: FormGroup
  TRANSACTIONSUMMARYRIBBONFORM = "transactionSummaryRibbonForm"
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$
  allComponentsData

  @Output() componentOutput = new EventEmitter<any>();
  @Output() documentManagerHandler = new EventEmitter<any>();
  @Output() policyManagerHandler = new EventEmitter<any>();
  @Output() medicalRiskHandler = new EventEmitter<any>();

  _state: string
  @Input() set state(value: any) {
    if(value){
      this._state = value
    }
  }
  get state() {
    return this._state
  }
  @Input() policyData: any;
  @Input() initialPayloadInEdit: any;
  @Input() configData: any;
  @Input() renderUsingConfig: any;
  @Input() type: string;
  @Input() RequirementEntityGuid: string;
  _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  inboxFullPrivilege = true
  _inboxType
  @Input()
  set InboxType(value: any) {
    if (value) {
      this._inboxType = value
      this.inboxFullPrivilege = !!!(this._inboxType == 'partner-inbox')
    }
  }
  get InboxType() {
    return this._inboxType
  }


  @Input() taskId: any;

  get lastUpdatedDate() {
    let DO = this.initialPayloadInEdit ? this.commonUtilty.getDO(this.initialPayloadInEdit) : null
    return DO ? DO.updatedDt : ''
  }

  get lastUpdatedUser() {
    let DO = this.initialPayloadInEdit ? this.commonUtilty.getDO(this.initialPayloadInEdit) : null
    return DO ? DO.updatedUser : ''
  }


  selectedpolicy: any;
  selectPolNum: any;
  proposalDOs: any = [];
  selectedClient: any;
  tempSelectedClient: any;
  progressPercentage
  setProgressPercent() {
    let DO = this.commonUtilty.getDOName(this.policyData);
    if (DO) {
      if (this.policyData[DO] && this.policyData[DO]['stageCd']) {
        switch (this.policyData[DO]['stageCd']) {
          case 'PENDING_DE':
            this.progressPercentage = 20;
            break;
          case 'PENDINGISSUANCE':
            this.progressPercentage = 60;
            break;
          case 'PENDINGDISPATCH':
            this.progressPercentage = 80;
            break;
          case 'PENDING_AUTO_UW':
            this.progressPercentage = 60;
            break;
          case 'PENDING_MANUAL_UW':
            this.progressPercentage = 60;
            break;
          case 'PENDINGDECLINE':
            this.progressPercentage = 80;
            break;
          case 'PENDING_COUNTER_OFFER':
            this.progressPercentage = 70;
            break;
          case 'PENDINGPAYOUT':
            this.progressPercentage = 90;
            break;
          case 'PENDINGMADJ':
            this.progressPercentage = 60;
            break;
          case 'PENDINGAUTOADJ':
            this.progressPercentage = 60;
            break;
          case 'PENDINGPAYOUTCLEARANCE':
            this.progressPercentage = 90;
            break;
          case 'PEDNINGVERIFICATION':
            this.progressPercentage = 90;
            break;
          default:
            this.progressPercentage = 0;
            break;
        }
      } else {
        this.progressPercentage = 0
      }
    } else {
      this.progressPercentage = 0
    }
    // if (this.state == 'proposal_ManualUw') {
    //   this.progressPercentage = 60
    // } else {
    //   if (this.policyData) {
    //     this.progressPercentage = 30
    //   }
    //   else
    //     this.progressPercentage = 0
    // }
  }


  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  // video call code
  modalUsrCall = false;
  modalUsrCallVideo = false;
  videoCallOngoing = false;
  videoCall(val) {
    this.videoCallOngoing = !!val;
  }


  policyPanelOpen = false;
  policyPanel(status) { this.policyPanelOpen = !!status }

  profilePanelOpen = false;
  profilePanel(status) { this.profilePanelOpen = !!status }

  allProfilePanelOpen = false;
  allProfilePanel(status) { this.allProfilePanelOpen = !!status }

  notesPanelOpen = false;
  notesPanel(status) { this.notesPanelOpen = !!status }

  corresPanelOpen = false;
  corresPanel(status) { this.corresPanelOpen = !!status }


  worksheetPanelOpen = false;
  worksheetPanel(status) { this.worksheetPanelOpen = !!status }


  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.corresPanel(0); //Close corresp panel (z index error fix)
  }

  policySummary(e) { this.policyManagerHandler.emit(e) }
  medicalRisk() { this.medicalRiskHandler.emit(true) }
  // Ribbon related
  workflowPanelOpen = false;
  showDropdown = false;
  workflowPanel(status, showDropdown: any = false) {
    this.showDropdown = showDropdown;
    this.workflowPanelOpen = !!status;
  }

  activityPanelOpen = false;
  activityPanel(status) {
    this.activityPanelOpen = !!status;
  }


  docuPanelOpen = false;
  docuPanel(status) {
    this.docuPanelOpen = !!status
  }

  documentOpenEmitTransation() {
    this.documentManagerHandler.emit(true)
  }

  uploadArray = [{}];
  addUploadRow() {
    let objPush = {};
    this.uploadArray.push(objPush)
  }
  removeUploadRow() {
    this.uploadArray.pop();
  }

  isNew: boolean = false;


  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.claimsBasicDetailsForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.claimsBasicDetailsForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  PolicyListAndInitializeRibbon$
  subscribeToPolicyListAndInitializeRibbon() {
    if (this.PolicyListAndInitializeRibbon$) this.PolicyListAndInitializeRibbon$.unsubscribe()
    this.PolicyListAndInitializeRibbon$ = this.interactService.policyListSubject$.subscribe(policies => {
      this.fetchAndInitializeRibbonDetails(policies)

      if (policies)
        this.policyData = this.commonUtilty.deepCopy(policies);
      if (policies && Array.isArray(policies) && policies.length == 0)
        this.selectedClient = null;
      this.setRibbonData();
    })
  }

  // subscribeToInsuredListAndInitializeRibbon1() {
  //   this.interactService.insuredSubject$.subscribe(insured => {
  //     console.log("Insured ", insured);
  //     this.tempSelectedClient = insured;
  //     if (this.tempSelectedClient) {
  //       this.clientService.getClientById(this.tempSelectedClient.id)
  //         .subscribe(resp => {
  //           this.selectedClient = resp;
  //           this.setRibbonData();
  //         },
  //           (error) => {
  //             throw " Something went wrong";
  //           }
  //         );
  //     }

  //   })
  // }

  subscribeToInsuredListAndInitializeRibbon() {
    this.interactService.insuredClientDOSubject$.subscribe(insured => {
      if (insured) {
        this.selectedClient = insured;
        this.setRibbonData();
      }
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }
  ribbonData = [];
  DOName = null
  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }

    this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    // this.subscribeToPolicyListAndInitializeRibbon()  //Subscription for Emitting PolicyList has been written.
    this.fetchAndInitializeRibbonDetails()
    this.fetchUserInfo();
    this.metaDataArray = (this.appMetadataHandler.transactionRibbonMetaData[this._state] || 
      this.appMetadataHandler.transactionRibbonMetaData['default']).filter(item => item.isVisible);
    //this.metaDataArray = this.commonUtilty.sortObject('sortOrder', this.metaDataArray, 'asc')
    this.subscribeToInsuredListAndInitializeRibbon();
    this.subscribeToPolicyListAndInitializeRibbon()  //Subscription for Emitting PolicyList has been written.
    this.setRibbonData();
    console.log("policy data", JSON.stringify(this.policyData));
    this.setProgressPercent()
    this.DOName = this.commonUtilty.getDOName(this.policyData);
  }


  userRole = null;
  fetchUserInfo(){
    let userInfo = this.userInfoService.getUserInfo();
    let userRoleDO = userInfo.userRoleDOList.find(item => true);
    this.userRole = userRoleDO.roleId;
  }

  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsBasicDetailsForm = this.fb.group({

    });
  }

  fetchAndInitializeRibbonDetails(policies?) {

    if (policies && policies != undefined) {
      this.proposalDOs = policies
      if (this.proposalDOs && this.proposalDOs.length > 0)
        this.selectPolNum = this.proposalDOs[0].proposalNum;
      this.isNew = true;
    }
    else {
      this.proposalDOs = this.getPolicyDO(this.policyData, this.state);
    }
    if (this.policyData) {
      this.selectedClient = this.getClinetDO(this.policyData);
      this.isNew = false;
    }
    else {
      this.selectedClient = this.tempSelectedClient;
    }

    this.selectedpolicy = this.getPolicyByNum(this.selectPolNum);
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.TRANSACTIONSUMMARYRIBBONFORM)
    return returnObj
  }


  getDO(IO) {
    if (IO)
      return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
    else
      null
  }

  getPolicyDO(IO, state) {
    let policy = []
    let DO = this.getDO(IO)
    if (DO != null) {
      policy = DO['policies'] || DO['policy']
      if (policy && policy.length > 0)
        this.selectPolNum = policy[0].proposalNum;

      // this.policyService.getPolicyByPolicyNum(this.selectPolNum).subscribe(resp => {
      //   console.log("resp ABC" +JSON.stringify(resp));
      //   this.selectedpolicy = resp.IO;
      // },
      //   (error) => {
      //     throw " Something went wrong";
      //   }
      // );
    } else if (state == 'proposal_ManualUw' || state == 'proposal_DataEntry' || state == 'proposal_CounterOffer' || state == 'TRAVELproposal_DataEntry' 
                || state == 'PROPERTYproposal_DataEntry' || state == 'MOTORproposal_DataEntry' || state == 'LIFEproposal_DataEntry'
                || state == 'LIFEproposal_ManualUw' || state=='LIFEproposal_CounterOffer' || state == 'MOTORproposal_ManualUw'|| state == 'TRAVELproposal_ManualUw' || state == 'PROPERTYproposal_ManualUw' || state == 'REFERRALS') {
      policy = DO
      if (policy)
        this.selectPolNum = policy['proposalNum'];
    }
    return policy;
  }


  // static contents later delete from here
  replacementArray: any = [
    { key: "Claimant Name", value: '%claimant_name%' },
    { key: "Claim Number", value: '%claim_number%' },
    { key: "Life-Assured Name", value: '%lifeassured_name%' },
    { key: "Missing Documents List", value: '%missing_documents%' },
  ];
  correspType: string = "email";
  correspondenceRichText: any = `
  <h3>Information regarding your proposal #P0000107<h3>
  <p>Dear %policyholder_name%,</p>
  <br>
  <p>We request you to submit %document_name% for %insured_name% at your earliest convenience.</p>
  <p>This would help us process your proposal </p>
  <br>
  <p>Thank you,</p><br>
  <p>Team StandardLife</p>
  `;
  handleFileUpload(data) {
    console.log(data);
  }
  correspondenceSubject: string = `Information regarding your proposal %proposal_number%: Missing Documents`;
  replacementSelected: any = null;
  replacementSelectedKaValue: any = null;
  replacementSelect(i) {
    this.replacementSelectedKaValue = i;
  }


  getPolicyByNum(proposalNum) {

    let output = {}
    if (proposalNum && this.proposalDOs && this.proposalDOs.length > 0) {
      output = this.proposalDOs.find(item => {
        if (item)
          return item['proposalNum'] === proposalNum;
      }) || []
    }
    else {
      if (this.proposalDOs && this.proposalDOs.length > 0)
        output = this.proposalDOs.find(item => true) || []
    }

    return output
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = '-'
    }
    return dateString
  }


  getClinetDO(IO) {
    let output = {}
    let DO = this.getDO(IO)
    if (DO != null && (IO['intimationDO'] || IO['claimDO'] || IO['proposalDO'])) {
      let clientDO = IO['clientDOs'];
      // let clientRoles = IO['intimationDO']['claimClientRoles'] || IO['claimDO']['claimClientRoles'];
      let clientRoles: any = [];
      if (IO['intimationDO'])
        clientRoles = IO['intimationDO']['claimClientRoles']

      if (IO['claimDO'])
        clientRoles = IO['claimDO']['claimClientRoles'];

      if (IO['proposalDO'])
        clientRoles = IO['proposalDO']['proposalClients'];

      let insureClientRef
      if(clientRoles && clientRoles.length > 0){
        insureClientRef = clientRoles.find(item => {
          if (item)
            return item['roleCd'] === 'INSURED';
        }) || []
  
      }
      if(this.commonUtilty.isArrayIterable(clientDO)){
        output = clientDO.find(item => {
          if (item)
            return item['guid'] === insureClientRef.clientRefGuid;
        }) || []
      }else{
        output = [];
      }
     
    }


    return output
  }



  claimRibbonObj: any;
  underwritingRibbonObj: any = {};
  setRibbonData() {

    this.claimRibbonObj = {
      proposalNum: [this.proposalDOs],
      commencementDt: this.getDateString(this.selectedpolicy['commencementDt'] || this.selectedpolicy['policyCommencementDt']) || '-',
      clmIntimationNum: this.getDO(this.policyData) ? this.getDO(this.policyData).clmIntimationNum : '-',
      claimNum: this.getDO(this.policyData) ? this.getDO(this.policyData).claimNum : '-',
      Insured: this.selectedClient && this.selectedClient != undefined ? this.commonUtilty.getFirstNameFromClient(this.selectedClient) : '-',
      claimedAmt: "-"
    }

    // TODO Ninad here we are receiving single policy
    if (this._state == "proposal_ManualUw" || this._state == "LIFEproposal_ManualUw" || this._state == "MOTORproposal_ManualUw" || this._state == "TRAVELproposal_ManualUw"
    || this._state == "PROPERTYproposal_ManualUw" || this._state == "REFERRALS") {
      if (this.policyData) {
        this.underwritingRibbonObj = {
          proposalNum: this.getDO(this.policyData) ? this.getDO(this.policyData).proposalNum : '-',
          stageCd: this.getDO(this.policyData) ? this.getDO(this.policyData).stageCd : '-',
          commencementDt: this.getDO(this.policyData) ? this.getDO(this.policyData).policyCommencementDt : '-',
          expiryDt: this.getDO(this.policyData) ? this.getDO(this.policyData).policyExpiryDt : '-',
          baseProductCd: this.getDO(this.policyData) ? this.getDO(this.policyData).baseProductCd : '-',
          productPlanOptionCd: this.getDO(this.policyData) ? this.getDO(this.policyData).productPlanOptionCd : '-',
          premiumStatusCd: this.getDO(this.policyData) ? this.getDO(this.policyData).premiumStatusCd : '-',
          statusCd: this.getDO(this.policyData) ? this.getDO(this.policyData).statusCd : '-',
          finalPremiumAmt: this.getDO(this.policyData) ? this.getDO(this.policyData).finalPremiumAmt : '-',
          sumInsuredAmt: this.getDO(this.policyData) ? this.getDO(this.policyData).sumInsuredAmt: '-',
          currencyCd: this.getDO(this.policyData) ? this.getDO(this.policyData).currencyCd : ''
        }
      }
    } else if (this._state == "proposal_DataEntry" || this._state == "proposal_CounterOffer" || this._state == "LIFEproposal_CounterOffer" || this._state == "TRAVELproposal_DataEntry" 
                || this._state == "PROPERTYproposal_DataEntry" || this._state == "MOTORproposal_DataEntry" || this. _state == "LIFEproposal_DataEntry") {
      if (this.policyData) {
        this.underwritingRibbonObj = {
          proposalNum: this.getDO(this.policyData) ? this.getDO(this.policyData).proposalNum : '-',
          stageCd: this.getDO(this.policyData) ? this.getDO(this.policyData).stageCd : '-',
          commencementDt: this.getDO(this.policyData) ? this.getDO(this.policyData).policyCommencementDt : '-',
          expiryDt: this.getDO(this.policyData) ? this.getDO(this.policyData).policyExpiryDt : '-',
          baseProductCd: this.getDO(this.policyData) ? this.getDO(this.policyData).baseProductCd : '-',
          productPlanOptionCd: this.getDO(this.policyData) ? this.getDO(this.policyData).productPlanOptionCd : '-',
          premiumStatusCd: this.getDO(this.policyData) ? this.getDO(this.policyData).premiumStatusCd : '-',
          statusCd: this.getDO(this.policyData) ? this.getDO(this.policyData).statusCd : '-',
          finalPremiumAmt: this.getDO(this.policyData) ? this.getDO(this.policyData).finalPremiumAmt : '-',
          sumInsuredAmt: this.getDO(this.policyData) ? this.getDO(this.policyData).sumInsuredAmt : '-',
          currencyCd: this.getDO(this.policyData) ? this.getDO(this.policyData).currencyCd : ''

        }
      }
    } else if (this._state == "policyServicingTask") {
        this.claimRibbonObj = {
          proposalNum: 'P0030547',//this.getDO(this.policyData) ? this.getDO(this.policyData).proposalNum : '-',
          commencementDt: '12 Nov 2018, 10:15 AM',//this.getDO(this.policyData) ? this.getDO(this.policyData).stageCd : '-',
          insuredName: 'Bill Gates',//this.getDO(this.policyData) ? this.getDO(this.policyData).policyCommencementDt : '-',
          policyStartDt: 'Rs. 1.20 Cr',//this.getDO(this.policyData) ? this.getDO(this.policyData).policyExpiryDt : '-',
          policyCover: 'aaa',//this.getDO(this.policyData) ? this.getDO(this.policyData).baseProductCd : '-',
          policyStatus: 'Active',//this.getDO(this.policyData) ? this.getDO(this.policyData).productPlanOptionCd : '-',
          premiumStatus: 'PAID',//this.getDO(this.policyData) ? this.getDO(this.policyData).premiumStatusCd : '-',
        }
    }
    else {
      this.underwritingRibbonObj = {
        proposalNum: null,
        stageCd: null,
        proposalEntryDt: null,
        statusCd: null,
        finalPremiumAmt: null,
        premiumStatusCd: null,

      }
    }
  }
  changeRibbonContains(proposalNum) {
    if (proposalNum && this.policyData && this.selectPolNum) {
      this.selectPolNum = proposalNum;
      this.selectedClient = this.getClinetDO(this.policyData);
      this.selectedpolicy = this.getPolicyByNum(this.selectPolNum);
      this.claimRibbonObj = null;
      this.setRibbonData();
    }

  }

  metaDataArray;



  // Below are the  static code later remove 

  selectedEmail: any;
  SelectedMob: any;
  caseIsFrozen: boolean = false;

  @Output() sendCaseStatus = new EventEmitter<any>();
  freezeToggle() {
    /* Message */
    if (this.caseIsFrozen) {
      // if (this.taskId) {
      this.message.loading('Unfreezing case ...', { nzDuration: 1200 });
      this.workQueueService.unfreezeTask(this.taskId).subscribe(res => {
        if (res != null) {
          console.log("unfreeze task response", JSON.stringify(res));
          this.sendCaseStatus.emit(this.caseIsFrozen);
        }
      })
    }
    else {
      if (this.taskId) {
        this.message.loading('Freezing case', { nzDuration: 1200 });
        this.workQueueService.freezeTask(this.taskId).subscribe(res => {
          if (res != null) {
            console.log("freeze task response", JSON.stringify(res));
            this.sendCaseStatus.emit(this.caseIsFrozen);
          }
        })
      }
    }
    /* Toggle */
    this.caseIsFrozen = !this.caseIsFrozen;
    // if(this.caseIsFrozen) {
    //   for (var key in this.permissions) {
    //     if (this.permissions.hasOwnProperty(key)) {
    //       this.permissions[key].edit = false;
    //     }
    //   }
    // }
    // else
    //   this.processStateVars(this.state);
  }

  isStarred: boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    this.workQueueService.markAsStarred(this.taskId).subscribe(res => {
      if (res != null) {
        this.isStarred = true;
        console.log("mark task as starred response", JSON.stringify(res));
      }
    })
    // setTimeout(() => {
    //   //this.message.success('#CLM0000107 added to you starred items', { nzDuration: 1200 });
    //   this.isStarred = true;
    // }, 1200);
  }

  /* Analytics */
  analyticsModal: boolean = false;
  fraudAnalyticsModal: boolean = false;
  medicalRiskModal: boolean = false;

  enableDataEntryMode() {
    this.dataTransformService.isSidebarCollapsed = !this.dataTransformService.isSidebarCollapsed;
  }

  similarCasesDataModal:boolean = false;
  similarUWdecisionList = [];
  searchSimilarCases: boolean = false;
  fetchSimilarCases() {
    this.similarCasesDataModal = true;
    this.searchSimilarCases = true;

    let DO = this.commonUtilty.getDOName(this.policyData);
    let caseDO = this.policyData[DO];
    if(caseDO){
      let req_payload = {
        "product_type": "LIFE_Claims_Dev",
        "business_process": "FWARISKANALYSIS",
        "module_name": "VisionIntelligence",
        "input_data": {
            "CASE_NUMBER": caseDO['proposalNum'],
            "PRODUCT_NAME": caseDO['baseProductCd'],
            "POLICY_START_DATE": caseDO['policyCommencementDt'] ? this.getDateData(new Date(caseDO['policyCommencementDt'])) : null,
            "TERM": caseDO['policyTerm'] || 1,
            "POLICY_EXPIRY_DT": this.getExpiryDate(caseDO['policyCommencementDt'], caseDO['policyExpiryDt'], caseDO['policyTerm']),
            "Primary_Insured_AGE": 43,
            "Primary_Insured_Gender": 1,
            "Primary_Insured_Height": 166,
            "Primary_Insured_Weight": 85,
            "Insured_AGE": 24,
            "Gender": "Male",
            "Height": 187,
            "Weight": 76,
            "SUM_INSURED": caseDO['sumInsuredAmt'] || 100000,
            "Other_Policies": this.commonUtilty.isArrayIterable(caseDO['othercases']) ? 'Yes' : 'No',
            "Claim taken": "Yes",
            "BMI": 31,
            "SMOKER": "N",
            "Alcoholic": "N",
            "diabetic": "N",
            "Hypertension": "N"
          }
      }

      this.investigationService.fetchSimilarCases(req_payload).subscribe(resp => {
        this.searchSimilarCases = false;
        if (resp && this.commonUtilty.isArrayIterable(resp)) {
          this.similarUWdecisionList = [...resp];
          console.log(resp);
        }
      }, (e) => {
        console.log("error occurred for similar case search: ", e)
        this.searchSimilarCases = false;
      });

    }
  }

  getDateData(dateValue){
    return this.datePipe.transform(dateValue, 'dd/MM/yyyy');
  }

  getExpiryDate(startDate, expiryDate, term) {
    if (expiryDate) {
      return this.getDateData(new Date(expiryDate))
    } else if (startDate) {
      let diff = term || 1;
      let date = new Date(startDate);
      date.setFullYear(date.getFullYear() + diff);
      return  this.getDateData(date)
    } else {
      return null;
    }
  }

  fetchedSimilarCaseDo = {};
  showSimilarCaseUWworksheet: boolean = false;
  fetchCaseByGuid(guid){
    this.policyService.getCaseByGuid(guid).subscribe(response => {
      if(response){
        this.fetchedSimilarCaseDo = this.commonUtilty.deepCopy(response);
        this.showSimilarCaseUWworksheet = true;
      }
    }, e=> {
      this.message.error("Unexpected error occurred. Please try again later or contact your system administrator.");
    });
  }

  riskSummarizationModal = false;
  riskSummarization(){
    this.riskSummarizationModal = true;
  }
}

